import React from "react";
import no_data from "../../assets/icons/no_records.png";

const NodataComponent = ({ msg }) => {
  return (
    <div className="d-flex-center flex-col mt1">
      <img
        src={no_data}
        alt=""
        style={{
          width: 120,
        }}
      />
      <p className="text-center mt1 no-records">
        {msg ? msg : "No records found"}
      </p>
    </div>
  );
};

export default NodataComponent;
